module.exports= {
    "postbox-text": "Digite seu comentário aqui (pelo menos 3 letras)",
    "postbox-author": "Nome (opcional)",
    "postbox-email": "E-mail (opcional)",
    "postbox-website": "Website (opcional)",
    "postbox-preview": "Prévia",
    "postbox-edit": "Editar",
    "postbox-submit": "Enviar",
    "postbox-notification": "Receber emails de notificação de respostas",

    "num-comments": "Um Comentário\n{{ n }} Comentários",
    "no-comments": "Nenhum comentário ainda",
    "atom-feed": "Feed Atom",

    "comment-reply": "Responder",
    "comment-edit": "Editar",
    "comment-save": "Salvar",
    "comment-delete": "Excluir",
    "comment-confirm": "Confirmar",
    "comment-close": "Fechar",
    "comment-cancel": "Cancelar",
    "comment-deleted": "Comentário apagado.",
    "comment-queued": "Comentário na fila de moderação.",
    "comment-anonymous": "Anônimo",
    "comment-hidden": "{{ n }} Oculto(s)",

    "date-now": "agora mesmo",
    "date-minute": "um minuto atrás\n{{ n }} minutos atrás",
    "date-hour": "uma hora atrás\n{{ n }} horas atrás",
    "date-day": "ontem\n{{ n }} dias",
    "date-week": "semana passada\n{{ n }} semanas atrás",
    "date-month": "mês passado\n{{ n }} meses atrás",
    "date-year": "ano passado\n{{ n }} anos atrás"
};
